import script from "./CompactPlayer.vue?vue&type=script&setup=true&lang=js"
export * from "./CompactPlayer.vue?vue&type=script&setup=true&lang=js"

import "./CompactPlayer.vue?vue&type=style&index=0&id=24999e5f&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24999e5f"]])

export default __exports__